import {gql} from '@apollo/client';

// page history response: String
export const GET_PAGE_HISTORY = gql`
    query Query($where: PageHistoryWhereInput) {
        getPageHistory(where: $where)
    }
`;

export const  GET_SUMMARY_MONEY = gql`
    query Query($where: SummaryWhereInput) {
        getSummaryMoney(where: $where)
    }
`;

export const  GET_SUMMARY_ORDER = gql`
    query Query($where: SummaryWhereInput) {
        getSummaryOrder(where: $where)
    }
`;

export const  GET_SUMMARY_STOCK = gql`
    query Query($where: SummaryWhereInput) {
        getSummaryStock(where: $where)
    }
`;